module.exports = __webpack_public_path__ + "img/zi_3.9baf985e.png";